import { render, staticRenderFns } from "./ProfileDataInModal.vue?vue&type=template&id=4882565a"
import script from "./ProfileDataInModal.vue?vue&type=script&lang=js"
export * from "./ProfileDataInModal.vue?vue&type=script&lang=js"
import style0 from "./ProfileDataInModal.vue?vue&type=style&index=0&id=4882565a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports